module.exports = __webpack_public_path__ + "static/media/ios-code-download.df5d303e.svg";